<ng-container *ngIf="selectedMachine">
  <div class="machine-info-wrapper">
    <img class="machine-image" src="{{ selectedMachine.imageStr }}" />
    <div class="serial-number">
      <label for="serialNumber">Serial Number</label>
      <input
        id="serialNumber"
        type="text"
        class="item"
        size="15"
        value="{{ selectedMachine.serialNumber }}"
        disabled
      />
    </div>
    <div class="machine-year">
      <label for="machine-year">Year</label>
      <input
        id="machine-year"
        type="text"
        class="item"
        size="15"
        value="{{ selectedMachine.year }}"
        disabled
      />
    </div>
    <div class="machine-name">
      <label for="machineName">Machine</label>
      <input
        id="machineName"
        type="text"
        class="item"
        size="30"
        value="{{ selectedMachine.name }}"
        disabled
      />
    </div>
    <div class="machine-operator">
      <label for="machineOperator">Operator</label>
      <input
        id="machineOperator"
        type="text"
        class="item"
        size="30"
        value="{{ selectedMachine.operator }}"
        disabled
      />
    </div>
    <div>
      <button
        mat-stroked-button
        color="accent"
        class="btn-error-list"
        (click)="onErrorListButtonClicked()"
      >
        Error list
      </button>
    </div>
  </div>
</ng-container>
